<div>
	<button
		#switchCustom
		type="button"
		role="switch"
		[ngClass]="{ 'switch-custom': true, 'disabled': disabled }"
		[attr.aria-checked]="checked"
		[attr.aria-label]="switchLabel"
		[disabled]="loading$ | async"
		(click)="onClick()"
	>
		<span class="switch-handle">
			<span class="switch-target" [ngClass]="{ 'justify-content-between': switchLabel }">
				@if (switchLabel) {
					<span class="switch-label" [attr.aria-checked]="getCheckedLabel(false)">{{ offLabel }}</span>
					<span class="switch-label" [attr.aria-checked]="getCheckedLabel(true)">{{ onLabel }}</span>
				} @else {
					<span class="switch-layer">
						<span class="switch-shape">
							<div class="switch-container">
								<app-icon *ngIf="dinamicIcon" class="icon" [iconName]="dinamicIcon" />
							</div>
						</span>
					</span>
				}
			</span>
		</span>
	</button>
</div>
